import { useEffect, useState } from 'react';

export const useDebounce = (value, delay, onDoneFun = () => {}) => {
    const [debounceValue, setDebounceValue] = useState(value);

    useEffect(() => {
        const fnId = setTimeout(() => {
            onDoneFun();
            setDebounceValue(value);
        }, delay);
        return () => clearTimeout(fnId);
    }, [value]);

    return debounceValue;
};
